import {collection, component, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {TaxReferenceData} from "../../system/tax/tax.data";
import {EmailSettingReferenceData} from "../../system/email-setting/email-setting.data";
import {AccountAddressBlockType} from "../account-address-block-type";
import {UncachedImageData} from "../../shared/image/uncached-image.data";

/**
 * this class holds AccountTypeData

 */
export class AccountTypeData extends LocalisableEntityData<AccountTypeData> {

    public static readonly DEBTOR = 1000;
    public static readonly EXPENSE = 1001;
    public static readonly OUTGOINGS = 1002;
    public static readonly VOUCHER = 1003;

    public static readonly BILLING_CYCLE_NONE = "none";
    public static readonly BILLING_CYCLE_WEEKLY = "weekly";
    public static readonly BILLING_CYCLE_MONTHLY = "monthly";

    @identifier id: number;
    @field name: string;
    // @field status: string;
    @field description: string;
    @collection(TaxReferenceData) applicableTaxes: TaxReferenceData[];
    @field accountLimited: boolean = false;
    @field limitDuration: boolean = false;
    @field paymentLimit: number;
    @field expiryPeriod: number;
    @field expiryPeriodUnitsDbValue: string = "MONTHS";
    @field externalCode: string;
    @field defaultTerms: number;
    @field deferWeekendDueDate: boolean;
    @field displayType: number = 1;
    @field authRequired: boolean = false;
    @field mgtOnly: boolean = false;
    @field applyPaymentsToInvoice: boolean = true;
    @field searchable: boolean = false;

    @field multipleContacts: boolean = false;
    @field invoicePrintCount: number;
    @field balanceTender: boolean = false;
    @field splitTender: boolean = false;
    @field lockOnOverdue: boolean = false;
    @field unlockOnPayment: boolean = true;
    @field printBalance: boolean = false;
    @field printBalanceOnAccountPayment: boolean = false;
    @field allowAccountRefunds: boolean = false;
    @field accountingType: number = 1000;

    @field statementTitle: string;
    @field statementHeader: string;
    @field useDefaultCompanyForStatements: boolean;
    @field statementAddressBlockTypeDbValue: string = AccountAddressBlockType.CONTACT;
    @field statementFooter: string;
    @field issueStatements: boolean;
    @component logoImage: UncachedImageData;

    @collection() validBillingCycles: string[];
    @field defaultBillingCycleDbValue: string;
    @field outgoingDenominations: boolean = false;
    @field detailLevel: string;

    @field statementEmailFrom: string;
    @field statementEmailSubject: string;
    @field statementEmailBody: string;
    @component statementEmailSettings: EmailSettingReferenceData;

    @field issueInvoices: boolean;
    @field invoiceEmailFrom: string;
    @field invoiceEmailSubject: string;
    @field invoiceEmailBody: string;
    @component invoiceEmailSettings: EmailSettingReferenceData;

    @field discontinued: boolean;
    @field requiresCustomerReference: boolean;
    @field splitAccountingExtract: boolean;
    @field manageIntercompanyLiability: boolean;
}
